module.exports = __webpack_public_path__ + "static/media/festivality-logo-bird.3464f429.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/festivality-logo-bird.png
// module id = 137
// module chunks = 0